<div class="p-6 max-w-7xl mx-auto">

  <div class="mb-8 border-b border-gray-200 pb-5">
    <h1 class="text-3xl font-extrabold text-gray-900 tracking-tight">Administración del Sistema</h1>
    <p class="text-gray-500 mt-2 text-base">Configura los catálogos maestros y la base de datos central del ERP.</p>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

    @for (modulo of modulosAdmin(); track modulo.id) {
      <a [routerLink]="modulo.ruta"
          class="group bg-white rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer flex flex-col h-full relative overflow-hidden">

        <div class="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-gradient-to-br from-transparent to-gray-50 rounded-full z-0 group-hover:scale-150 transition-transform duration-500"></div>

        <div class="relative z-10 flex items-start gap-5">
          <div [class]="'p-4 rounded-xl flex-shrink-0 ' + modulo.bg + ' ' + modulo.color">
            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="modulo.icono"></path>
            </svg>
          </div>

          <div>
            <h3 class="text-xl font-bold text-gray-900 group-hover:text-[#1e3a8a] transition-colors">{{ modulo.titulo }}</h3>
            <p class="text-gray-500 text-sm mt-2 leading-relaxed">{{ modulo.descripcion }}</p>
          </div>
        </div>

        <div class="mt-auto pt-4 flex justify-end relative z-10">
          <div class="flex items-center text-sm font-bold text-[#1e3a8a] opacity-0 -translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
            Ingresar al catálogo
            <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>
          </div>
        </div>
      </a>
    }

  </div>
</div>
